import { render } from "./WalkthroughItem.vue?vue&type=template&id=80dca642&scoped=true&ts=true"
import script from "./WalkthroughItem.vue?vue&type=script&lang=ts"
export * from "./WalkthroughItem.vue?vue&type=script&lang=ts"

import "./WalkthroughItem.scss?vue&type=style&index=0&id=80dca642&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80dca642"]])

export default __exports__